export enum ArpMediaType {
  SONG = 'song',
  SAMPLE = 'sample',
  STEM = 'stem'
}
